import { __extends } from "tslib";
import React from 'react';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';
import s from './FullscreenDeviationPage.scss';
var FullscreenPage = /** @class */ (function (_super) {
    __extends(FullscreenPage, _super);
    function FullscreenPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FullscreenPage.prototype.render = function () {
        var deviation = this.props.deviation;
        return (React.createElement("div", { className: s['root'] },
            React.createElement(ArtStage, { deviation: deviation }),
            React.createElement(ActionBar, { deviation: deviation })));
    };
    return FullscreenPage;
}(React.Component));
export { FullscreenPage };
export default FullscreenPage;
//# sourceMappingURL=FullscreenDeviationPage.js.map